

let wishMechanismDefault: Array<IDic> = [
    { 'id': '1', name: '文冲' },
    { 'id': '2', name: '长洲' },
    { 'id': '3', name: '新造' },
    { 'id': '5', name: '新雅' },
    { 'id': '4', name: '其他' },
];

export const oldNewColumns: Array<IDic> = [
    { name: "全新", id: "全新" },
    { name: "9成新", id: "9成新" },
    { name: "8成新", id: "8成新" },
    { name: "其他", id: "其他" },
];

import runEvn from '../../runEvn/RunEvn'
if (runEvn().evn == "shanchen") {
    wishMechanismDefault = [
        { 'id': 'shanchen-1', name: '苏孟乡' },
        { 'id': 'shanchen-2', name: '汤溪镇' },
        { 'id': 'shanchen-3', name: '罗埠镇' },
        { 'id': 'shanchen-4', name: '洋埠镇' },
        { 'id': 'shanchen-5', name: '秋滨街道' },
        { 'id': 'shanchen-6', name: '三江街道' },
        { 'id': 'shanchen-7', name: '西关街道' },
        { 'id': 'shanchen-8', name: '江南街道' },
        { 'id': 'shanchen-00', name: '其他' },
    ];
}
export const wishMechanism = wishMechanismDefault;

